export class CybermetrieParamsAMC {
    estEmprunteurUnique?: boolean
    estEmprunteurPrimaire?: boolean
    estNouvelleMarge?: boolean
    parcours?: string
    noDemande?: string;
}